// config.js
// const API_URL = 'http://localhost:11000/api/v1';
// const API_URL = 'https://tzh-crm-backend-l6l6.onrender.com';
// const API_URL = 'https://thezulahousecrm.in/api/v1';
// const API_URL = 'https://new.thezulahousecrm.in/api/v1';
const API_URL = 'https://crm.thezulahouse.com/api/v1';

export { API_URL };
